import styled, { css } from 'styled-components';
import { VerificationCard } from 'src/pages/VerificationPage/components/VerificationPageFlow/VerificationPageSuccessPageFlow.styled';
import {CTAButton} from 'src/common/components/Button';
import { ToastWrapper } from 'src/common/components/Toast';
import { media } from 'src/common/styles/breakpoints';

export const FormBackground = styled(VerificationCard)`
  min-height: 18rem;
  padding: 0.75rem 0.75rem 0.5rem;
`;

export const FormItem = styled.div`
  margin-bottom: 0.5rem;

  :last-of-type {
    margin-bottom: 1rem;
  }
`;

export const FormSubmitButton = styled(CTAButton)`
  height: 4.25rem;
  margin-bottom: 0.5rem;
`;

export const StyledToastWrapper = styled(ToastWrapper)`
  width: 22.4375rem;
  justify-content: left;
  padding: 0.75rem 1rem;

  ${media.w.min.px576(css`
    width: 39.0625rem;
    padding: 1rem 1.5rem 0.9375rem 1rem;
  `)}
`;
